import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RequestBase } from '../../base/request-base';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { NotifyService } from '../../services/notify.service';
import * as AppConst from '../../data/test.data';
import { SidebarService } from '../../sidebar/sidebar.service';
import { AuthenService } from '../../services/authen.service';
import { SelectEventArgs } from '@syncfusion/ej2-angular-dropdowns';
import { UrlParams } from '../../helpers/url-params';
import { ChangeEventArgs } from '@syncfusion/ej2-buttons';
import { Util } from '../../helpers/global.util';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { debug } from 'util';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { saveAs as importedSaveAs } from "file-saver";

declare global {
    interface Navigator {
        clipboard: {
            writeText(text: string): Promise<void>;
        };
    }
}


@Component({
    selector: '',
    templateUrl: './admin-sql.html',
    styleUrls: ['./admin-sql.css'],
})
export class AdminSQLComponent implements OnInit, OnDestroy {

    waiting: boolean = false;
    isQueryType: string = "READ";

    queryDDL: Array<any> = [
        { label: 'READ', value: "READ" },
        { label: 'WRITE', value: "WRITE" },
        { label: 'HELPTEXT', value: "HELPTEXT" }
    ];

    rowsEffected: number =-1;
    errMess: string = "";
    queryString: string = "";
    dbName: string = "Tenderprocess";
    nameValueFields: Object = { text: 'label', value: 'value' };    
    arrDB = [
        { label: 'Tender_New', value: "Tender_New" },
        { label: 'Tenderprocess', value: "Tenderprocess" },
        { label: 'TenderLog', value: "TenderLog" }
    ]

    tablesMenu: Array<any> = [];
    public gridData: Array<any> = [];
    public columnNames: string[] = [];   // Danh sách tên cột tự động
    public pageSettings: Object = { pageSize: 30 };
    @ViewChild('grid')
    public grid?: GridComponent;

    isWaitingExcute: boolean = false;
    helpTextResultString: string = "";

    /*Templates management*/

    @ViewChild('gridFile') gridFile;
    gridListfiles: DataManager;


    pathFile: string = "D:/Projects/OnSVN/ZPV/TenderProcess/MediBID/wwwroot";
    apiUploadTemplate: string = "api/AdminSQL/UploadTemplate";

    pathFileUnZip: string = "";

    constructor(private http: HttpService, private auth: AuthenService, private route: ActivatedRoute, private helper: HelperService, private router: Router) {
       // this.pageSettings = { pageSize: 30 };
    }

    ngOnInit() {
        this.GetTableSchemaDB();
    }

    ngOnDestroy() {

    }

    validdate() {
        
    }

    onExcuteClick() {

        if (this.queryString == null || this.queryString == "") {
            this.helper.alertFailed('Query must not empty');
        }
        else
        {
            const cleanQuery = this.queryString.trim().toLowerCase();
           
           
            this.isWaitingExcute = true;
            if (this.isQueryType == "READ")
            {

                let paramPost = {
                    "dbName": this.dbName,
                    "queryString": btoa(unescape(encodeURIComponent(this.queryString))),
                    "queryType": this.isQueryType
                };

                //=== Query là kiểu select===============
                this.http.postManual(`api/AdminSQL/ExcuteSelectQuery`, paramPost, res => {
                   
                    this.isWaitingExcute = false;
                    // 1. Reset dữ liệu và cột cũ trước để xóa trạng thái cũ của Grid
                    this.gridData = [];
                    this.columnNames = [];

                    if (res && res.Data && res.Data.length > 0) {
                        // Dùng setTimeout nhỏ hoặc gán trực tiếp để Angular kích hoạt cơ chế Change Detection
                        setTimeout(() => {
                            this.gridData = res.Data;
                            this.columnNames = Object.keys(res.Data[0]);
                            // Refresh lại grid sau khi đã cập nhật xong cột và data
                            if (this.grid) { this.grid.refresh(); }
                        }, 50);
                    }
                    else {
                        this.gridData = [];
                        this.columnNames = [];

                        if (this.grid) {
                            this.grid.refreshColumns();
                            this.grid.refresh();
                        }
                    }

                    this.errMess = res.ErrorMessages;
                });


            }
            else if (this.isQueryType == "WRITE")
            {
                //================= WRITE chia làm 2 loại ======================


                let paramPostWrite = {
                    "dbName": this.dbName,
                    "queryString": btoa(unescape(encodeURIComponent(this.queryString))),
                    "queryType": this.isQueryType
                };


                //=== Query là kiểu Inser/update/delete..===============
                this.http.postManual(`api/AdminSQL/PostExcuteNoQuery`, paramPostWrite, res => {
                    debugger;
                    this.isWaitingExcute = false;
                    this.rowsEffected = res.LongID;
                    this.errMess = res.ErrorMessages;
                });
            }
            else if (this.isQueryType == "HELPTEXT")
            {
                let paramPostHelptext = {
                    "dbName": this.dbName,
                    "queryString": this.queryString,
                    "queryType": this.isQueryType
                };
                this.http.postManual(`api/AdminSQL/ExcuteHelpTextQuery`, paramPostHelptext, res => {
                    this.isWaitingExcute = false;
                    this.helpTextResultString = res.Result;
                    this.errMess = res.ErrorMessages;
                });
            } 


           
        }
      
    }


    GetTableSchemaDB() {
        this.http.get(`api/AdminSQL/GetTableInDB?dbName=${this.dbName}`, res => {
            this.tablesMenu = res.map((table: any) => ({...table,isOpen: false}));
        });
    }

    toggleTable(table: any) {
        table.isOpen = !table.isOpen;
    }
    onDBChange(event: any) {
        debugger;
        if (event && event.value) {
            this.dbName = event.value;
            this.tablesMenu = [];
            this.GetTableSchemaDB();
        }
    }

    onQueryTypeChange(event: any) {
        debugger;
        if (event && event.value) {
            this.isQueryType = event.value;
        }
    }

    onCancelExcute(){
        this.helper.alertFailed("Chưa code");
    }


    /*==================================Template management====================== */
    onListTemplates() {
        this.gridListfiles = this.http.getByManager(`api/AdminSQL/ViewListFiles?pathview=${this.pathFile}`, this.auth);
    }

    onDownload(item: any) {

        let encryPathDown = btoa(unescape(encodeURIComponent(item.PathFile)));
        this.http.download(`api/AdminSQL/DownloadTemplate?pathdown=${encryPathDown}`, res => {
            importedSaveAs(res, item.Name);
        });
    }


    onCopyPathURL(item: any){
        let pathFileCopy = this.pathFile + "/" + item.Name;
        navigator.clipboard.writeText(pathFileCopy);
        this.helper.alert(pathFileCopy);

        
  
    }


    onDeleteFile(item: any) {
        this.helper.confirm('Are you sure to delete this file: '+item.Name+' ?', () => {
            this.http.post(`api/AdminSQL/DeleteFile/`, item, res =>
            {
                if (res.ID != 0)
                {
                    this.helper.alert('Delete successfully');
                    this.onListTemplates();
                } 
               
            });
        });
    }
    onUnZipFile()
    {
        if (this.pathFileUnZip != "" && this.pathFileUnZip != null) {
            this.helper.confirm('Are you sure to unZip file?', () => {

                let encryPathUnZip = btoa(unescape(encodeURIComponent(this.pathFileUnZip)));


                this.http.get(`api/AdminSQL/UnZip?pathUnZip=${encryPathUnZip}`, res => {
                    if (res.ID != 0) {
                        this.helper.alert("UnZip successfully !");
                        this.pathFileUnZip = "";
                    }
                });
            });
        } else {
            this.helper.alertFailed("Please fill unZip path file !");
        }


       


        
    }

    onActionBegin(evt: any) {
    }

}

